import * as React from 'react'
import { List, styled, Divider } from '@mui/material'

const TextLabel = styled('div')(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: 'normal',
  fontSize: '0.85em',
  lineHeight: '1.25em',
}))

const TextDivider = ({ label, display, stylelabel }) => {
  if (display) return null
  return (
    <>
      <List>
        <TextLabel sx={stylelabel}>{label}</TextLabel>
      </List>
      <Divider />
    </>
  )
}

export default TextDivider
